import { render, staticRenderFns } from "./reaction-btn.vue?vue&type=template&id=6c5bf077"
import script from "./reaction-btn.vue?vue&type=script&lang=js"
export * from "./reaction-btn.vue?vue&type=script&lang=js"
import style0 from "./reaction-btn.vue?vue&type=style&index=0&id=6c5bf077&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports